'use client';

import { MenuItem, TextField, TextFieldProps, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import { useTheme } from '@dh/hooks';
import { BodyMedium, Row } from '@dh/styles';

const TextFieldLabel = ({ label, required }: { label: string; required?: boolean }) => {
    const { colors } = useTheme();

    return (
        <Row stretch>
            <BodyMedium color={colors.onSurfaceVariant} mr={0.5}>
                {label}
            </BodyMedium>
            {required ? <BodyMedium color={colors.primary}>*</BodyMedium> : null}
        </Row>
    );
};

type Option = {
    value: string | number;
    displayText: string;
};

type Props = TextFieldProps & {
    labelText?: string;
    withLabel?: boolean;
    errorText?: string;
    options: Option[];
};

export const DHPSelect = ({
    labelText,
    withLabel = true,
    options,
    required,
    errorText,
    helperText,
    ...props
}: Props) => {
    const t = useTranslations('forms');
    const { colors } = useTheme();
    const hasError = props.error && !!errorText;
    return (
        <>
            <TextField
                select
                label={
                    withLabel ? (
                        <TextFieldLabel
                            label={labelText ?? t('select_placeholder')}
                            required={required}
                        />
                    ) : undefined
                }
                helperText={hasError ? errorText : helperText}
                sx={{ fieldset: { borderColor: colors.onSurfaceVariant } }}
                {...props}
            >
                {options.map(({ value, displayText }) => (
                    <MenuItem key={value} value={value}>
                        <Typography>{displayText}</Typography>
                    </MenuItem>
                ))}
            </TextField>
        </>
    );
};
